module.exports = __webpack_public_path__ + "static/media/62-aec-2-aa-27665-aaf-6-a-51208393-dd-76-fa@2x.7f1194f2.png";